import React, {useEffect} from 'react'
import { useQuery } from 'react-query'
import SimpleSpinner from '../components/Loader/SimpleSpinner'
import ResultTweet from '../components/Tweet/ResultTweet'
import { getFilteredTopics } from '../services/tweetService'
import { useSelector } from 'react-redux'
import { selectCurrentCategoryId, selectDataId } from '../store/feed/feedSelector.js'
import { pusher } from '../services/pusherService.js'
import { queryClient } from '../CONSTANTS/index.js'
export default function ExploreNews() {
  const state = useSelector((state) => state);
  const categoryId = selectCurrentCategoryId(state);
  const dataId = selectDataId(state);
  useEffect(() => {
    // Define the event listener cleanup function
    const cleanupEventListener = () => {
      pusher.unsubscribe("topics");
    };

    // Clean up the event listener when the component unmounts
    return cleanupEventListener;
  }, []);

  const bindChannel = (data) => {
    let feed = data;
    const channel = pusher.subscribe("topics");
    channel.bind("update-counter", (response) => {
      const i = feed.findIndex((el) => el.id === response.id);
      if (i > -1) {
        feed[i] = response;
        console.log(feed);
        queryClient.setQueryData("rejected-projects", feed);
      }
    });
  };
  const {isLoading,data,error} = useQuery('rejected-projects',() => getFilteredTopics(4, categoryId, dataId), {
    refetchOnWindowFocus: false,
    cacheTime: 0, 
    onSuccess: bindChannel,
staleTime: 0
  });
  
  return (
    <>
      {isLoading ? <SimpleSpinner topCenter/> : data && data.map(tweet => <ResultTweet tweet={tweet} key={tweet.id}/>)}
      {error && <p className='error error-text'>{error}</p>}
    </>
  )
}
